import { DatePipe } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Subscription } from 'rxjs';
import { Assignor } from 'src/app/models/assignor';
import { Auth } from 'src/app/models/auth';
import { CentroCusto } from 'src/app/models/centro-custo';
import { Departamento } from 'src/app/models/departamento';
import { OrderItemDetails } from 'src/app/models/order-item-paged';
import { Pedido, PedidoItem } from 'src/app/models/pedido';
import { Order, OrderItens, Purchase, PurchaseItens } from 'src/app/models/purchase';
import { SaveDepositRequest } from 'src/app/models/request/depositos-request';
import { GerarPixDinamico } from 'src/app/models/request/gerar-pix-dinamico';
import { OrderItemRequest } from 'src/app/models/request/order-item-request';
import { BRCodePix } from 'src/app/models/response/brcode-pix';
import { QRCodePixDinamico } from 'src/app/models/response/pix-qrcode';
import { Unidade } from 'src/app/models/unidade';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CedenteService } from 'src/app/services/cedente.service';
import { CentroCustoService } from 'src/app/services/centro-custo.service';
import { DepartamentoService } from 'src/app/services/departamento.service';
import { DepositoService } from 'src/app/services/deposito.service';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { TransactionService } from 'src/app/services/transaction.service';
import { UnidadeService } from 'src/app/services/unidade.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { SituacaoCompra } from 'src/app/shared/enums/situacao-compra.enum';
import { SituacaoPedidoItem } from 'src/app/shared/enums/situacao-pedido-item.enum';
import { SituacaoPedido } from 'src/app/shared/enums/situacao-pedido.enum';
import { StatusApp } from 'src/app/shared/enums/status-app.enum';
import { PurchaseConverter } from 'src/app/shared/helpers/converters/purchase-converter';
import { DropDownItem } from 'src/app/shared/helpers/models/dropdown-item';
import { PdfService } from 'src/app/shared/services/pdf.service';
import { environment } from 'src/environments/environment';
import { VisualizarBoletoService } from '../../../visualizar-boleto/visualizar-boleto.service';


@Component({
    selector: 'app-minhas-compras-details',
    templateUrl: './minhas-compras-details.component.html',
    styleUrls: ['./minhas-compras-details.component.css']
})
export class MinhasComprasDetailsComponent implements OnInit, OnDestroy {

    private id: number;
    private routeSubscription: Subscription;
    private currentUser: Auth;
    public pedido: Pedido;
    public auxQRCode: BRCodePix;
    public order: Order;
    public orderId: number;
    public SituacaoPedidoItem = SituacaoPedidoItem;
    public purchase: Purchase;
    public purchaseItens: PurchaseItens[];
    public SituacaoPedido = SituacaoPedido;
    public SituacaoCompra = SituacaoCompra;
    public pedidoItemToDesprovisionar: OrderItens;
    public orderItemToDesprovisionar: OrderItens;
    public pedidoItemToReprocessar: PedidoItem;
    public purchaseItensModal: PurchaseItens[];
    public comentarios: string[] = [];
    public qrCodePix: QRCodePixDinamico;
    public assignorInfo: Assignor;
    public orderItems: OrderItemDetails[] = [];
    public orderItemsList: OrderItemDetails[] = [];
    public showCola: boolean = false;
    public productDescription: string;


    //#region filtro DropDown
    public filtroCentroCustoDropDownList = [];
    public filtroCentroCustoSelectedItems = [];
    public filtroUnidadeDropDownList = [];
    public filtroUnidadeSelectedItems = [];
    public filtroDepartamentoDropDownList = [];
    public filtroDepartamentoSelectedItems = [];

    public dropDownSettings: IDropdownSettings = {};

    public centrosCustosList: CentroCusto[];
    public unidadesList: Unidade[];
    public departamentosList: Departamento[];
    public filtroCodigo = '';
    public filtroNome = '';
    public filtroCPF = '';
    public filtroMatricula = '';
    public filtroCentroCusto: string;
    public filtroUnidade: string;
    public filtroDepartamento: string;
    public filtroAplicativo = null;
    public filtroPesquisa = '';
    public filtroSituacao = null;
    sortOrder: boolean = false;
    //#endregion

    // páginação
    productsPage = 1;
    currentPage = 1;
    showItem = '25';
    totalItems = 0;
    collumnName = "name";
    constructor(
        private pedidoService: PedidoService, private router: Router, private route: ActivatedRoute, private cedenteService: CedenteService,
        private authenticationService: AuthenticationService, private modalService: NgbModal, private pedidoDataService: PedidoDataService,
        private visualizarBoletoService: VisualizarBoletoService, private transactionService: TransactionService,
        private alertService: NewAlertService, private centroCustoService: CentroCustoService, private unidadeService: UnidadeService,
        private departamentoService: DepartamentoService,
        private depositoService: DepositoService,
        public datepipe: DatePipe) { }

    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
    }

    ngOnInit() {
        this.routeSubscription = this.route.paramMap.subscribe(params => {
            this.id = +params.get('id');
        });

        this.currentUser = this.authenticationService.currentUserValue;
        this.loadInfo();
        this.auxQRCode = new BRCodePix();

        if (this.id) {
            this.pedidoService.getPurchaseById(this.id, this.currentUser.token.assignorGuid, true).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso || (response.status === ApiError.Insucesso && response.result)) {
                        this.purchase = response.result;
                        this.auxQRCode = response.result?.pix;
                        this.purchaseItens = this.purchase.purchaseItens;
                        this.purchase.purchaseItens = this.purchase.purchaseItens.sort((a,b)=> (a.order.productCategory > b.order.productCategory) ? -1 : (a.order.orderValue > b.order.orderValue) ? -1 : 1);

                        if(response.status === ApiError.Insucesso)
                            this.alertService.error(response.message);

                    } else {
                        this.router.navigate(['list'], {relativeTo: this.route.parent});
                        this.alertService.error(response.message);
                    }
                },
                error => { this.alertService.error(error); }
            );
        } else {
            this.alertService.error('Pedido não encontrado', true);
        }
    }

    getOrderItems(event, orderId?: number) {
        this.orderId = orderId;

        this.currentPage = event;
        const offset = this.currentPage - 1;

        const filterObject = new OrderItemRequest();

        filterObject.name = this.filtroNome;
        filterObject.document = this.filtroCPF;
        filterObject.register = this.filtroMatricula;
        filterObject.orderby = this.collumnName;
        filterObject.ordertype = this.sortOrder;
        filterObject.situation = this.filtroSituacao;
        filterObject.hasApp = this.filtroAplicativo == "" ? null : this.filtroAplicativo;

        this.filtroCentroCustoSelectedItems.forEach(obj => {
            filterObject.costCenter.push(+obj.ITEM_ID);
        });
        this.filtroUnidadeSelectedItems.forEach(obj => {
            filterObject.unit.push(+obj.ITEM_ID);
        });
        this.filtroDepartamentoSelectedItems.forEach(obj => {
            filterObject.departament.push(+obj.ITEM_ID);
        });

        this.alertService.clear();
        this.pedidoService
            .getOrderItemsOrderId(
                this.orderId,
                this.currentUser.token.assignorGuid,
                offset,
                +this.showItem,
                filterObject
            )
            .subscribe(
                response => {

                    if (response.status === ApiError.Sucesso) {
                        this.orderItems = response.result.orderItem;
                        for (const s of this.orderItems) {
                            if(s.document == 0) s.document = null;
                            if(s.document != null){
                                const tam =
                                    environment.TOTAL_CARACTERE_CPF -
                                    s.document.length;
                                let str = s.document.toString();

                                for (let i = 0; i < tam; i++) {
                                    str = '0' + str;
                                }

                                s.document = str;
                            }

                            if (s.costCenter === null) {
                                s.costCenter = 'Nenhum';
                            }

                            if (s.unit === null) {
                                s.unit = 'Nenhum';
                            }

                            if (s.departament === null) {
                                s.departament = 'Nenhum';
                            }

                            s.situationDescription = this.capitalize(s.situationDescription);
                        }

                        this.orderItemsList = this.orderItems;
                        for (const s of this.orderItems) {
                            if(s.document == 0) s.document = null;
                            if(s.document != null){
                                const tam = environment.TOTAL_CARACTERE_CPF - s.document.length;
                                let str = s.document.toString();

                                for (let i = 0; i < tam; i++) {
                                    str = '0' + str;
                                }
                                s.document = str;
                            }
                        }
                        this.totalItems = response.result.totalResults;
                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    this.alertService.error(
                        'Ocorreu um erro ao paginar favorecidos'
                    );
                }
            );
    }

    //#region DropDown methods
    public loadFiltroDropDown() {
        this.centroCustoService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.centrosCustosList = response.result;
                this.centrosCustosList.forEach(obj => {
                    this.filtroCentroCustoDropDownList.push(
                        new DropDownItem(obj.centroCustoId.toString(), obj.nome)
                    );
                });
            });

        this.unidadeService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.unidadesList = response.result;
                this.unidadesList.forEach(obj => {
                    this.filtroUnidadeDropDownList.push(
                        new DropDownItem(obj.unidadeId.toString(), obj.nome)
                    );
                });
            });

        this.departamentoService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.departamentosList = response.result;
                this.departamentosList.forEach(obj => {
                    this.filtroDepartamentoDropDownList.push(
                        new DropDownItem(
                            obj.departamentoId.toString(),
                            obj.nome
                        )
                    );
                });
            });

        this.dropDownSettings = {
            singleSelection: false,
            idField: 'ITEM_ID',
            textField: 'ITEM_TEXT',
            selectAllText: 'Selecionar Tudo',
            unSelectAllText: 'Desmarcar Tudo',
            searchPlaceholderText: 'Buscar',
            allowSearchFilter: true,
            itemsShowLimit: 3
        };
    }

    onItemSelectFiltroCentroCusto(item: any) { }
    onSelectAllFiltroCentroCusto(items: any) { }
    onItemDeSelectFiltroCentroCusto(items: any) { }

    onItemSelectFiltroUnidade(item: any) { }
    onSelectAllFiltroUnidade(items: any) { }
    onItemDeSelectFiltroUnidade(items: any) { }

    onItemSelectFiltroDepartamento(item: any) { }
    onSelectAllFiltroDepartamento(items: any) { }
    onItemDeSelectFiltroDepartamento(items: any) { }
    //#endregion

    changeLimit(event){
        this.showItem = event;
        this.getOrderItems(this.currentPage, this.orderId);
    }

    private loadInfo() {
        if(JSON.parse(localStorage.getItem('assignorInfo')) == null || JSON.parse(localStorage.getItem('assignorInfo')) == undefined)   {
            this.cedenteService.getAssignorInfo(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                response => {
                    this.assignorInfo = response.result;
                    localStorage.setItem('assignorInfo', JSON.stringify(response.result));

                    const tam = environment.TOTAL_CARACTERE_CNPJ - this.assignorInfo.document.toString().length;

                    let str =  this.assignorInfo.document.toString();

                    for (let i = 0; i < tam; i++) { str = '0' + str; }
                        this.assignorInfo.document = str;
                }, error => {
                    this.alertService.error('Ocorreu um erro ao consultar as informações da empresa. Tente novamente mais tarde');
                }
            );
        }
        else{
            this.assignorInfo = JSON.parse(localStorage.getItem('assignorInfo'));
            const tam = environment.TOTAL_CARACTERE_CNPJ -  this.assignorInfo.document.toString().length;

            let str = this.assignorInfo.document.toString();

            for (let i = 0; i < tam; i++) { str = '0' + str; }
                this.assignorInfo.document = str;
        }
    }

    generateDeposit() {
        
        const saveDepositRequest = new SaveDepositRequest();
        saveDepositRequest.purchaseId = this.purchase.purchaseId;
        saveDepositRequest.personGuid = this.currentUser.token.pessoaId
        saveDepositRequest.value = this.purchase.purchaseValue;
        saveDepositRequest.depositType = this.purchase.paymentMethodId == 4 ? 5 : this.purchase.paymentMethodId; 
        saveDepositRequest.isNewGeneration = true;
        
        this.depositoService.saveDeposit(
            this.currentUser.token.assignorGuid,
            saveDepositRequest
        ).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {              
                    window.location.reload();

                } else {
                this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
            }
        );
    }

    loadQRCode(){
        const depositoPixRequest = new GerarPixDinamico();
        depositoPixRequest.cnpjCedente =  this.assignorInfo.document;
        depositoPixRequest.valor = this.pedido.valor;
        depositoPixRequest.nomeCedente =  this.assignorInfo.nickName;
        depositoPixRequest.numeroPedido = this.pedido.destino.identificador.toString();
        //console.log(depositoPixRequest);
        this.transactionService.GerarPixDinamico(depositoPixRequest).subscribe(
            response => {
              if (response.status === ApiError.Sucesso) {
                  /* console.log(response) */

                this.qrCodePix = new QRCodePixDinamico();
                this.qrCodePix = response.result;

              } else {
                this.alertService.error(response.message);
              }
            }, error => {
              this.alertService.error('Ocorreu um erro ao visualizar intenção de depósito');
            }
          );
    }

    ngOnDestroy() {
        this.routeSubscription.unsubscribe();
    }

    showColaboradores(orderId: number, productDescription: string) {
        this.productDescription = productDescription;
        this.showCola = true;
        this.getOrderItems(1,orderId);
    }

    showReprocessar(content: any, pedidoItem: PedidoItem) {
        this.pedidoItemToReprocessar = pedidoItem;
        this.modalService.open(content, { centered: true });
    }

    showDesprovisionar(content: any, orderItem: OrderItens) {
        this.orderItemToDesprovisionar = orderItem;
        this.modalService.open(content, { centered: true });
    }

    reprocessar(order: Order, orderItem: OrderItens) {
        this.pedidoService.reprocessarPedidoItem(order.orderId, orderItem.orderItemId, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.alertService.success(response.message);
                    window.location.reload();
                    this.pedido.pedidoItens = this.pedido.pedidoItens.filter(x => x.pedidoItemId !== orderItem.orderItemId);
                    response.result.colaboradorDocumento = response.result.colaboradorDocumento.toString();
                    const tam = environment.TOTAL_CARACTERE_CPF - response.result.colaboradorDocumento.length;
                    let str = response.result.colaboradorDocumento.toString();
                    for (let i = 0; i < tam; i++) {
                        str = '0' + str;
                    }
                    response.result.colaboradorDocumento = str;
                    this.pedido.pedidoItens.push(response.result);

                    this.pedido.pedidoItens = this.pedido.pedidoItens.sort((a, b) => a.pedidoItemId.toString().localeCompare(b.pedidoItemId.toString()));
                } else {
                    this.alertService.error(response.message);
                }
            }, error => { this.alertService.error(error); }
        );
    }

    desprovisionar(orderItem: OrderItens) {
        console.log(orderItem)
        let orderId = this.orderId;
        this.pedidoService.desprovisionarPedidoItem(this.purchase.purchaseId,orderId, orderItem.orderItemId, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.alertService.success(response.message);
                    window.location.reload();
                    this.pedido.pedidoItens = this.pedido.pedidoItens.filter(x => x.pedidoItemId !== orderItem.orderItemId);
                    response.result.colaboradorDocumento = response.result.colaboradorDocumento.toString();
                    const tam = environment.TOTAL_CARACTERE_CPF - response.result.colaboradorDocumento.length;
                    let str = response.result.colaboradorDocumento.toString();
                    for (let i = 0; i < tam; i++) {
                        str = '0' + str;
                    }
                    response.result.colaboradorDocumento = str;
                    this.pedido.pedidoItens.push(response.result);
                    this.pedido.valor = this.pedido.valor - response.result.valor;
                    this.pedido.pedidoItens = this.pedido.pedidoItens.sort((a, b) => a.pedidoItemId.toString().localeCompare(b.pedidoItemId.toString()));

                } else {
                    this.alertService.error(response.message);
                }
            }, error => { this.alertService.error("Não foi possível desprovisionar o favorecido"); }
        );
    }

    continuar() {
        if (this.purchase.purchaseState === SituacaoCompra.EmCriacao) {
            this.pedidoDataService.setCurrentPurchaseValue(PurchaseConverter.purchaseToPurchase(this.purchase));
            if (this.purchase.isFlexPurchase) {
                this.router.navigate(['portal/novarecarga/selecionargrupocolaborador']);
            } else {
                this.router.navigate(['portal/novarecarga/selecionarcolaborador']);
            }
        } else if (this.purchase.purchaseState === SituacaoCompra.Rascunho) {
            this.purchase.managerGuid = this.currentUser.token.userReferenceId
            this.purchase.purchaseItens.forEach(pi => {
                pi.ehEditavel = true;
                pi.order.orderItens.forEach(oi => {
                    oi.referenceValue = oi.providedValue;
                })
            });
            this.pedidoDataService.setCurrentPurchaseValue(this.purchase);
            this.router.navigate(['portal/novarecarga/selecaoperiodo']);
        } else {
            this.alertService.error('Situação inválida para continuar a recarga');
        }
    }

    copiar() {
        if (this.purchase.purchaseState !== SituacaoCompra.EmCriacao) {
            this.pedidoService.getPurchaseById(this.purchase.purchaseId, this.currentUser.token.assignorGuid, false).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.pedidoDataService.setCurrentPurchaseValue(PurchaseConverter.purchaseToNewPurchase(response.result));
                        if(this.purchase.isFlexPurchase){
                            this.router.navigate(['portal/novarecarga/selecionargrupocolaborador']);
                        }else{
                            this.router.navigate(['portal/novarecarga/selecionarcolaborador']);
                        }
                    } else {
                        this.alertService.error(response.message);
                    }
                }, error => { this.alertService.error(error.error); }
              );
        } else {
            this.alertService.error('Situação inválida para copiar a recarga');
        }
    }

    verificaAplicativo(statusApp: StatusApp) {
        return statusApp === StatusApp.Ativo;
    }

    openBoleto() {
        this.visualizarBoletoService.arquivoBase64 = this.purchase?.boleto.arquivo;
        this.router.navigate(['portal/boleto']);
    }

    showModalQRCodePIX(content:any){
        if(this.purchase.pix)
            this.purchase.pix = this.auxQRCode;

        this.modalService.open(content, { centered: true});
    }

    details(pedido: Order) {
        //console.log(pedido);
        //console.log(pedido.orderItens);
        this.router.navigate([`portal/meuspedidos/details/${pedido.orderId}`]);
    }

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    applyFilter(
        nome: string,
        cpf: string,
        matricula: string,
        centroCusto: [],
        unidade: [],
        departamento: [],
        aplicativo: string,
        situacao: string
    ) {
        this.filtroNome = nome;
        this.filtroCPF = cpf;
        this.filtroMatricula = matricula;
        this.filtroCentroCustoSelectedItems = centroCusto;
        this.filtroUnidadeSelectedItems = unidade;
        this.filtroDepartamentoSelectedItems = departamento;
        this.filtroAplicativo = aplicativo;
        this.filtroSituacao = situacao;

        this.getOrderItems(1,this.orderId);
    }

    capitalize(word: string){
        const lower = word.toLowerCase();
        return word.charAt(0).toUpperCase() + lower.slice(1);
    }

    exportPdf(){

        const result: any = this.purchase;

        const purchase = {
            id: result.purchaseId,
            products: result.products,
            quantity: result.products.length,
            purchaseDate: this.datepipe.transform(result.purchaseDate, 'dd/MM/yyyy HH:mm'),
            releaseDate: (!(result.purchaseState === SituacaoCompra.NaoProcessado || result.purchaseState === SituacaoCompra.Cancelado) && result.purchaseItens[0].order.releaseDate) ? this.datepipe.transform(result.purchaseItens[0].order.releaseDate, 'dd/MM/yyyy HH:mm') : null,
            purchaseValue: result.purchaseValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            purchaseToPayValue: result.purchaseToPayValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            paymentMethodDescription: result.paymentMethodDescription ? result.paymentMethodDescription : 'Saldo em conta',
            purchaseFee: result.purchaseFee.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            purchaseValueToDeliver: result.purchaseValueToDeliver.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            purchaseStateDescription: result.purchaseStateDescription,
        };

        const headers = [];
        const values = [];
        const purchaseItens = [];

        result.purchaseItens.forEach((item) => {
            const lr = new Array<string>();
            lr.push(item.order.productDescription);
            headers.push(item.order.productDescription);
            lr.push(item.order.orderValueToDeliver.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
            lr.push(item.order.orderDescription);
            lr.push(item.order.orderStateDescription);
            purchaseItens.push(lr);

            let value = []
            item.order.orderItens.forEach((itemOrder,i) => {
                value.push(itemOrder.providedValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
            });
            values.push(value);
        });

        const rows = [];

        result.purchaseItens[0].order.orderItens.forEach((item, i) => {
            const lr = new Array<string>();
            lr.push(item.name.toLocaleUpperCase());
            lr.push(item.document);
            lr.push(item.registry);
            for (const s of values){
                lr.push(s[i].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
            }
            rows.push(lr);
        });

        const orderItems = { headers: headers, rows: rows };
        // const orderItems = [];
        const orderItemsError = [];

        result.purchaseItens.forEach((pi) => {
            pi.order.orderItens.forEach((oi,i) => {
                const lr = new Array<string>();
                if ([6,5,3].includes(oi.orderItemState)){
                    lr.push(oi.name.toLocaleUpperCase());
                    lr.push(oi.document);
                    lr.push(oi.registry);
                    lr.push(pi.order.productDescription);
                    lr.push(oi.providedValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
                    lr.push(oi.orderItemStateDescription);
                    orderItemsError.push(lr);
                }
            });
        });



        let date = new Date();
        const pdfService = new PdfService();
        pdfService.generatePdfPurchases(purchase, purchaseItens, orderItems, orderItemsError).getBlob((blob) => {
            saveAs(blob, 'resumo_recarga_' + purchase.id + '_' + this.datepipe.transform(date, 'yyyyMMdd') + '.pdf');
        });
    }

}
